<template>
    <v-container class="pt-10">

        <template v-for="(item, index) in dataMyStore">
            <section :id="item.slug" class="mb-10" :key="index" v-if="item.products.length > 0">
                <h2 class="mb-5 text-capitalize font-weight-bold text-h4 text-md-h3" :class="fontFamily" :style="`color:${titleColor}`">{{ item.name }}</h2>
                <v-row>
                    <v-col cols="12" sm="6" md="4" v-for="(prod, j) in item.products" :key="j">
                        <v-card
                            class="mx-auto"
                            color="grey lighten-4"
                            max-width="600"
                            :disabled="emergency"
                        >
                            <v-img
                                :aspect-ratio="item.size_banner"
                                :src="prod.banner"
                                style="cursor:pointer;"
                                @click="openDetails(prod.id)"
                            >
                                <div class="tag-promo" v-if="prod.promo">Oferta</div>
                            </v-img>
                            <v-card-text
                                class="pt-4 pb-0"
                                style="position: relative;"
                            >
                                <!-- <v-btn
                                    absolute
                                    :color="btnColor"
                                    :style="{color: textbtnColor}"
                                    fab
                                    large
                                    right
                                    top
                                    @click="openDetails(prod.id)"
                                >
                                    <v-icon>mdi-cart</v-icon>
                                </v-btn> -->
                                <!-- <h3 class="font-weight-light mb-0" :style="{'color':contentColor}"> -->
                                <h3 class="font-weight-light mb-0" :style="{'color':titleCardColor}">
                                    {{ prod.name }}
                                </h3>
                                <v-list-item three-line class="pa-0">
                                    <v-list-item-content class="py-0" v-if="prod.description">
                                        <v-list-item-subtitle :style="{'color':contentColor, 'fontSize':'16px'}" v-html="prod.description"></v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-card-text>
                            <v-card-actions v-if="prod.price">
                                <div v-if="prod.stock">
                                    {{$t('Sólo')}} {{ prod.stock }} {{$t('en stock')}}
                                </div>
                                <v-spacer></v-spacer>
                                <div class="mb-2 text-right" v-if="prod.special_price" :style="{'color':priceColor}">
                                    <span class="font-weight-light text-decoration-line-through grey--text">
                                        {{ money }} {{ prod.price }}
                                    </span>
                                    <span class="title">
                                        {{ money }} {{ prod.special_price }}
                                    </span>
                                </div>
                                <div class="mb-2 text-right" v-else :style="{'color':priceColor}">
                                    <span class="title">
                                        {{ money }} {{ prod.price }}
                                    </span>
                                </div>
                            </v-card-actions>
                            <v-card-actions v-else>
                                <div class="mb-2">&nbsp;</div>
                            </v-card-actions>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    :color="btnColor"
                                    :style="{color: textbtnColor}"
                                    @click="openDetails(prod.id)"
                                    v-if="prod.type == 'product'"
                                >{{$t('Agregar al carrito')}}</v-btn>
                                <v-btn
                                    :color="btnColor"
                                    :style="{color: textbtnColor}"
                                    @click="openDetails(prod.id)"
                                    v-if="prod.type == 'service'"
                                >{{$t('Reservar')}}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </section>
        </template>


        <!-- dialog -->
        <v-dialog
            v-model="dialogProd"
            width="500"
            scrollable
            :fullscreen="$vuetify.breakpoint.smAndDown"
            transition="dialog-bottom-transition"
        >
            <v-skeleton-loader
                v-if="loadProd"
                class="white"
                type="card-avatar, article, actions"
            ></v-skeleton-loader>
            <v-card
                v-else
                class="mx-auto"
            >
                <v-overlay
                    absolute
                    :value="overlayProd"
                    opacity=".8"
                >
                    <v-progress-circular
                        indeterminate
                        size="64"
                        color="success"
                    ></v-progress-circular>
                </v-overlay>
                <v-fab-transition>
                    <v-btn
                        absolute
                        right
                        fab
                        small
                        style="top: 10px;"
                        @click="dialogProd=!dialogProd, loadProd=!loadProd"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-fab-transition>

                <v-card-text class="pb-5 px-0">
                    <v-card-title :style="`color:${navColor}`" class="pa-0">
                        <v-carousel
                            height="auto"
                            class="simple-carousel"
                            :show-arrows="(galleryProd.length<=0)?false:true"
                            hide-delimiters
                            style="min-height: 250px;"
                            v-if="bannerProd != 'none'"
                        >
                            <v-carousel-item
                                class="white"
                                contain
                            >
                                <v-img
                                    :src="bannerProd"
                                    :lazy-src="bannerProd"
                                >
                                    <template v-slot:placeholder>
                                        <v-row
                                            class="fill-height ma-0"
                                            align="center"
                                            justify="center"
                                        >
                                            <v-progress-circular
                                                indeterminate
                                                :color="btnColor"
                                            ></v-progress-circular>
                                        </v-row>
                                    </template>
                                </v-img>
                            </v-carousel-item>
                            <v-carousel-item
                                v-for="(img, j) in galleryProd" :key="j"
                                class="white"
                                contain
                            >
                                <v-img
                                    :src="img.img"
                                    :lazy-src="img.img"
                                >
                                    <template v-slot:placeholder>
                                        <v-row
                                            class="fill-height ma-0"
                                            align="center"
                                            justify="center"
                                        >
                                            <v-progress-circular
                                                indeterminate
                                                :color="btnColor"
                                            ></v-progress-circular>
                                        </v-row>
                                    </template>
                                </v-img>
                            </v-carousel-item>
                        </v-carousel>
                        <div class="px-4 py-2" style="width:100%" :style="{'color':titleCardColor}">
                            {{ nameProd }}
                        </div>
                    </v-card-title>

                    <div class="px-5 mb-5" v-if="descriptionProd" :style="{'color':contentColor, 'fontSize':'16px'}" v-html="descriptionProd"></div>

                    <template v-for="(row, j) in optionsProd">
                        <v-card-title :key="j" class="py-3" :style="{backgroundColor: navColor, color: textnavColor}">
                            {{ row.title }}
                        </v-card-title>
                        <v-alert
                            :key="j+1*150"
                            dense
                            tile
                            outlined
                            type="error"
                            v-if="showAlertRequired && row.isRequired"
                        >Debe seleccionar una opción para continuar</v-alert>
                        <!-- multiple -->
                        <v-list :key="j+10" v-if="row.type == 'multiple'">
                            <!-- select quantity -->
                            <template dense>
                                <v-list-item v-for="(opt) in row.values" :key="opt.name">
                                    <v-list-item-content>
                                        <v-list-item-title>{{ opt.name }}</v-list-item-title>
                                        <v-list-item-subtitle v-if="(+opt.price)>0">{{ money }} (+{{ opt.price }})</v-list-item-subtitle>
                                    </v-list-item-content>

                                    <div class="d-flex align-center mr-3" v-if="row.ifQuantity">
                                        <v-btn
                                            small
                                            :disabled="opt.quantity<=0"
                                            @click="changeQtyMultiple(row, opt, -1)"
                                        >
                                            <v-icon dark>
                                                mdi-minus
                                            </v-icon>
                                        </v-btn>
                                        <v-sheet
                                            height="28"
                                            width="60"
                                            class="sheet-cant"
                                        >
                                            {{ opt.quantity }}
                                        </v-sheet>
                                        <v-btn
                                            small
                                            :disabled="(opt.quantity<=0 && (row.tmpVal).length >= row.select) || (row.selectQuantity && row.values.reduce((t, o) => t + (+o.quantity || 0), 0) >= row.selectQuantity)"
                                            @click="changeQtyMultiple(row, opt, 1)"
                                        >
                                            <v-icon dark>
                                                mdi-plus
                                            </v-icon>
                                        </v-btn>
                                    </div>

                                    <span :id="`${opt.name.replace(' ', '-')}_${opt.price}`" :data-details="`${opt.name}:${opt.price}:${opt.quantity}`"></span>

                                    <!-- con cantidad, la selección se hace con +/- (cantidad > 0 = seleccionado) -->
                                    <v-list-item-action v-if="!row.ifQuantity">
                                        <v-checkbox
                                            v-model="row.tmpVal"
                                            :value="`${opt.name.replace(' ', '-')}_${opt.price}`"
                                            :color="btnColor"
                                            :disabled=" ((row.tmpVal).includes(`${opt.name.replace(' ', '-')}_${opt.price}`)) ? false : ((row.tmpVal).length >= row.select) "
                                            @change="changeRespMultiple"
                                        ></v-checkbox>
                                    </v-list-item-action>
                                </v-list-item>
                            </template>
                        </v-list>
                        <!-- multiple end -->
                        <!-- only -->
                        <v-list :key="j+20" v-if="row.type == 'only'">
                            <v-list-item-group
                                v-model="row.tmpValOnly"
                                active-class=""
                                @change="changeRespOnly"
                            >
                                <v-list-item v-for="(opt) in row.values" :key="opt.name" :value="opt.name+':'+opt.price">
                                    <template v-slot:default="{ active }">
                                        <v-list-item-content>
                                            <v-list-item-title>{{ opt.name }}</v-list-item-title>
                                            <v-list-item-subtitle v-if="(+opt.price)>0">{{ money }} (+{{ opt.price }})</v-list-item-subtitle>
                                        </v-list-item-content>

                                        <v-list-item-action>
                                            <v-icon :color="btnColor" v-if="active">
                                                mdi-circle-slice-8
                                            </v-icon>
                                            <v-icon v-else>
                                                mdi-checkbox-blank-circle-outline
                                            </v-icon>
                                        </v-list-item-action>
                                    </template>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                        <!-- only end -->
                    </template>

                    <v-divider></v-divider>

                    <!-- services -->
                    <v-card v-if="typeProd=='service'" tile elevation="0">
                        <v-card-text class="pa-0">
                            <v-card-title class="py-3 blue-grey lighten-5">
                                {{$t('Reserva tu hora')}}
                            </v-card-title>
                            <v-form ref="refService" lazy-validation class="pa-3">
                                <v-row>
                                    <v-col cols="6">
                                        <v-text-field
                                            :label="$t('Nombre completo *')"
                                            :color="btnColor"
                                            outlined
                                            dense
                                            v-model="fullName"
                                            :rules="[rules.required]"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field
                                            :label="$t('Número de celular *')"
                                            :color="btnColor"
                                            outlined
                                            dense
                                            v-model="phoneNumber"
                                            type="number"
                                            :rules="[rules.required, rules.min]"
                                        >
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-dialog
                                            ref="dialog"
                                            v-model="menu1"
                                            :return-value.sync="dateFormatted"
                                            persistent
                                            width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <!-- @blur="dateReservation = parseDate(dateFormatted)" -->
                                            <v-text-field
                                                v-model="dateFormatted"
                                                :label="$t('Fecha *')"
                                                append-icon="mdi-calendar"
                                                dense
                                                outlined
                                                readonly
                                                :color="btnColor"
                                                :rules="[rules.required]"
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="dateReservation"
                                                locale="es-Bo"
                                                :color="btnColor"
                                                class="ma-0"
                                                scrollable
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    text
                                                    :color="btnColor"
                                                    @click="menu1 = false"
                                                >
                                                    {{$t('Cancelar')}}
                                                </v-btn>
                                                <v-btn
                                                    :color="btnColor"
                                                    :style="`color:${textbtnColor}`"
                                                    @click="$refs.dialog.save(formatDate(dateReservation))"
                                                >
                                                    {{$t('OK')}}
                                                </v-btn>
                                            </v-date-picker>
                                        </v-dialog>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-dialog
                                            ref="dialog2"
                                            v-model="menu2"
                                            :return-value.sync="timeReservation"
                                            persistent
                                            width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="timeReservation"
                                                :label="$t('Hora *')"
                                                append-icon="mdi-clock-time-four-outline"
                                                readonly
                                                outlined
                                                dense
                                                :color="btnColor"
                                                :rules="[rules.required]"
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                            </template>
                                            <v-time-picker
                                                v-if="menu2"
                                                v-model="timeReservation"
                                                full-width
                                                :color="btnColor"
                                                class="ma-0"
                                            >
                                                <!-- format="24hr" -->
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    text
                                                    :color="btnColor"
                                                    @click="menu2 = false"
                                                >
                                                    {{$t('Cancelar')}}
                                                </v-btn>
                                                <v-btn
                                                    :color="btnColor"
                                                    :style="`color:${textbtnColor}`"
                                                    @click="$refs.dialog2.save(timeReservation)"
                                                >
                                                    {{$t('OK')}}
                                                </v-btn>
                                            </v-time-picker>
                                        </v-dialog>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-card-text>
                    </v-card>

                    <div class="px-3 pt-5">
                        <v-textarea
                            outlined
                            :placeholder="(typeProd=='service')?$t('Incluir un comentario para la reserva'):$t('Dato extra')"
                            :color="btnColor"
                            rows="3"
                            v-model="dataExtra"
                        ></v-textarea>
                    </div>

                </v-card-text>

                <v-card-actions v-if="!emergency">
                    <!-- product -->
                    <v-row no-gutters align="center" v-if="typeProd=='product'">
                        <v-col cols="6">
                            <div class="d-flex align-center">
                                <v-btn icon small @click="changePlusAndMinus('minus')" :disabled="quantity<=1">
                                    <v-icon dark>
                                        mdi-minus
                                    </v-icon>
                                </v-btn>
                                <v-text-field
                                    placeholder="Cantidad"
                                    :color="btnColor"
                                    outlined
                                    dense
                                    type="number"
                                    min="1"
                                    step="1"
                                    :max="stock"
                                    hide-details
                                    v-model="quantity"
                                    style="width:100px;max-width:100px;"
                                    @input="changeQuantity($event)"
                                ></v-text-field>
                                <v-btn icon small @click="changePlusAndMinus('plus')" :disabled="quantity>=stock">
                                    <v-icon dark>
                                        mdi-plus
                                    </v-icon>
                                </v-btn>
                            </div>
                        </v-col>
                        <v-col cols="6">
                            <v-btn
                                large
                                block
                                rounded
                                :color="btnColor"
                                :style="`color:${textbtnColor}`"
                                @click="addToCart"
                                class="text-capitalize"
                            >
                                <strong>{{$t('Agregar')}} {{ money }} {{ (quantity * price) + respMultipleVal + respOnlyVal }}</strong>
                            </v-btn>
                            <v-btn
                                dark
                                large
                                block
                                rounded
                                v-if="consultWps"
                                color="#43bf51"
                                class="text-capitalize mt-2"
                                :href="`https://wa.me/${codePhone}${storePhone}?text=Hola!%20${storeName},%20quisiera%20realizar%20una%20consulta%20sobre%0a--->%20${nameProd}%0a`"
                                target="_blank"
                            >
                                <strong>{{$t('Consultar')}}</strong>
                                <v-icon right>
                                    mdi-whatsapp
                                </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <!-- services -->
                    <v-row no-gutters align="center" v-if="typeProd=='service'">
                        <v-col cols="12" v-if="tempMode=='order_generate'">
                            <v-btn
                                large
                                block
                                rounded
                                :color="btnColor"
                                :style="`color:${textbtnColor}`"
                                class="text-capitalize mb-2"
                                @click="openPreviewReservation"
                            >{{$t('Generar reserva')}}</v-btn>
                            <v-btn
                                dark
                                large
                                block
                                rounded
                                v-if="consultWps"
                                color="#43bf51"
                                class="text-capitalize mt-2"
                                :href="`https://wa.me/${codePhone}${storePhone}?text=Hola!%20${storeName},%20quisiera%20realizar%20una%20consulta%20sobre%0a--->%20${nameProd}%0a`"
                                target="_blank"
                            >
                                <strong>{{$t('Consultar')}}</strong>
                                <v-icon right>
                                    mdi-whatsapp
                                </v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="12" v-else>
                            <v-btn
                                large
                                block
                                rounded
                                :color="btnColor"
                                :style="`color:${textbtnColor}`"
                                @click="sendServices"
                                class="text-capitalize"
                                :loading="loadingServ"
                            >
                                <strong>{{$t('Reservar')}}</strong>
                            </v-btn>
                            <v-btn
                                dark
                                large
                                block
                                rounded
                                v-if="consultWps"
                                color="#43bf51"
                                class="text-capitalize mt-2"
                                :href="`https://wa.me/${codePhone}${storePhone}?text=Hola!%20${storeName},%20quisiera%20realizar%20una%20consulta%20sobre%0a--->%20${nameProd}%0a`"
                                target="_blank"
                            >
                                <strong>{{$t('Consultar')}}</strong>
                                <v-icon right>
                                    mdi-whatsapp
                                </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- end dialog -->

        <!-- generate -->
        <v-dialog
            v-model="dialogGenerate"
            width="500"
            scrollable
            :fullscreen="$vuetify.breakpoint.smAndDown"
            transition="dialog-bottom-transition"
        >
            <v-card>
                <v-card-title>
                    {{$t('Vista previa del pedido')}}
                </v-card-title>
                <v-card-text>
                    <div style="white-space: break-spaces;" v-html="contentOrder"></div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        rounded
                        large
                        text
                        color="error"
                        class="text-capitalize"
                        @click="dialogGenerate=false"
                    >{{$t('Volver')}}</v-btn>
                    <v-btn
                        dark
                        large
                        rounded
                        color="#43bf51"
                        class="text-capitalize"
                        @click="sendReservationWhatsApp"
                    >
                        {{$t('Enviar reserva')}}
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- generate END -->
    </v-container>
</template>
<script>
export default {
    data() {
        return {
            overlayProd: false,
            loadProd: true,
            dialogProd: false,
            prodId: '',
            bannerProd: '',
            galleryProd: [],
            nameProd: '',
            typeProd: '',
            descriptionProd: '',
            optionsProd: [],
            quantity: 1,
            price: null,
            stock: 500,
            dataExtra: '',
            respMultiple: [],
            respMultipleVal: 0,
            respOnly: [],
            respOnlyVal: 0,
            showRequired: false,
            showAlertRequired: false,
            // reservation
            menu1: false,
            menu2: false,
            fullName: '',
            phoneNumber: '',
            dateReservation: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            dateFormatted: this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
            timeReservation: '14:00',
            loadingServ: false,
            // validation
            rules: {
                required: v => !!v || 'El campo es requerido',
                requiredDates: v => v.length>0 || 'El campo es requerido',
                min: v => v.length >= 8 || 'Mínimo 8 caracteres',
                phone: v => (v.length >= 8 && v.length <= 8) || 'Debe contener 8 dígitos',
                email: v => /.+@.+\..+/.test(v) || 'Correo electrónico inválido'
            },
            // generate
            dialogGenerate: false,
            contentOrder: ''
        }
    },
    props: [
        'slug',
        'titleColor',
        'titleCardColor',
        'priceColor',
        'btnColor',
        'textbtnColor',
        'bannerColor',
        'textnavColor',
        'navColor',
        'fontFamily',
        'dataMyStore',
        'consultWps',
        'storePhone',
        'codePhone',
        'storeName',
        'emergency',
        'money',
        'contentColor',
        'tempMode'
    ],
    // mounted() {
    //     setTimeout(() => {
    //         console.log(this.tempMode);
    //     }, 300);
    // },
    computed: {
        computedDateFormatted () {
            return this.formatDate(this.date)
        },
    },
    watch: {
        dialogProd(e) {
            if (!e) {
                this.respMultiple = []
                this.respMultipleVal = 0

                this.respOnly = []
                this.respOnlyVal = 0

                this.dataExtra = ''

                this.optionsProd = []
            }
        },
        dateReservation (val) {
            this.dateFormatted = this.formatDate(this.date)
        },
    },
    methods: {
        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        parseDate (date) {
            if (!date) return null

            const [day, month, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },

        changeQtyMultiple(row, opt, step) {
            const key = `${opt.name.replace(' ', '-')}_${opt.price}`
            const newQty = Math.max(0, opt.quantity + step)
            // respetar la cantidad máxima de todos los complementos juntos
            if (step > 0 && row.selectQuantity && row.values.reduce((t, o) => t + (+o.quantity || 0), 0) + step > row.selectQuantity) return
            const isSelected = row.tmpVal.includes(key)

            if (newQty > 0 && !isSelected) {
                // respetar el máximo de opciones permitidas
                if (row.tmpVal.length >= row.select) return
                row.tmpVal.push(key)
            }
            if (newQty == 0 && isSelected) {
                row.tmpVal.splice(row.tmpVal.indexOf(key), 1)
            }

            opt.quantity = newQty
            this.changeRespMultiple()
        },
        changeRespMultiple() {
            this.verifyRequireds()
            setTimeout(() => {
                var tmpListComplements = []
                this.optionsProd.forEach(element => {
                    element.tmpVal.forEach(val => {
                        const selectedId = document.getElementById(val)
                        const dataSelected = selectedId.getAttribute('data-details')
                        tmpListComplements.push(dataSelected)
                    });
                });
                // console.log(tmpListComplements);
                this.respMultipleVal = 0
                if (tmpListComplements.length > 0) {
                    tmpListComplements.forEach(el => {
                        // console.log(el);
                        let valSelected = el.split(':')
                        let tmpPrice = (+valSelected[1]) * (+valSelected[2])
                        this.respMultipleVal += tmpPrice
                    });
                }
                this.respMultiple = tmpListComplements
            }, 500);
        },
        changeRespOnly() {
            this.verifyRequireds()
            const tmpListOnly = []
            this.optionsProd.forEach(element => {
                if (element.tmpValOnly) {
                    tmpListOnly.push(element.tmpValOnly)
                }
            });

            this.respOnlyVal = 0
            if (tmpListOnly.length > 0) {
                tmpListOnly.forEach(el => {
                    let tmpPrice = +(el.split(':')[1])
                    this.respOnlyVal += tmpPrice
                });
            }
            // console.log(tmpListOnly);
            this.respOnly = tmpListOnly
        },
        verifyRequireds() {
            for (let i = 0; i < this.optionsProd.length; i++) {
                const element = this.optionsProd[i];
                if (element.isRequired) {
                    if (element.type == 'multiple') this.showRequired = (element.tmpVal.length<=0)
                    if (element.type == 'only') this.showRequired = (element.tmpValOnly==undefined)
                }
                if (this.showRequired) break
            }
        },
        openDetails(id) {
            this.loadProd = true
            this.dialogProd = true
            axios.get(`/show-product/${id}`)
            .then((response) => {
                // console.log(response);
                this.prodId = response.data.id
                const tmpBanner = response.data.banner.split('/');
                this.bannerProd = (tmpBanner.slice(-1)[0]!='img-default.png') ? response.data.banner : 'none'
                this.galleryProd = response.data.gallery
                this.nameProd = response.data.name
                this.typeProd = response.data.type
                this.descriptionProd = response.data.description
                if (response.data.complements.length > 0) {
                    response.data.complements.forEach(element => {
                        var tmpVal = JSON.parse(element.values)
                        var multiRequired = []
                        var onlyRequired = undefined
                        tmpVal.forEach(val => {
                            // multiple con cantidad empieza en 0 (no seleccionado)
                            val.quantity = (element.type == 'multiple' && element.quantity) ? 0 : 1
                        });
                        if (element.type == 'multiple') {
                            for (let i = 0; i < tmpVal.length; i++) {
                                const val = tmpVal[i];
                                if (element.required) {
                                    val.quantity = 1
                                    // multiRequired.push(`${val.name}:${val.price}:${val.quantity}`)
                                    multiRequired.push(`${val.name.replace(' ', '-')}_${val.price}`)
                                    setTimeout(() => {
                                        this.changeRespMultiple()
                                    }, 300);
                                    break
                                }
                            }
                        }
                        if (element.type == 'only') {
                            for (let i = 0; i < tmpVal.length; i++) {
                                const val = tmpVal[i];
                                if (element.required) {
                                    onlyRequired = val.name+':'+val.price
                                    setTimeout(() => {
                                        this.changeRespOnly()
                                    }, 300);
                                    break
                                }
                            }
                        }
                        // const selectRequired = `${opt.name.replace(' ', '-')}_${opt.price}`
                        this.optionsProd.push({
                            title: element.title,
                            type: element.type,
                            values: tmpVal,
                            select: element.select,
                            selectQuantity: (+element.select_quantity > 0) ? +element.select_quantity : null,
                            tmpVal: multiRequired,
                            tmpValOnly: onlyRequired,
                            ifQuantity: element.quantity,
                            quantity: 1,
                            isRequired: (element.required)?true:false
                        })
                        if (element.required) {
                            this.showRequired = true
                        }
                    });
                }
                this.price = (response.data.special_price) ? response.data.special_price : response.data.price
                this.quantity = 1

                setTimeout(() => {
                    this.loadProd = false
                }, 800);
            })
            .catch((error) => {
                console.log(error);
            })
        },
        // chabge quantity
        changeQuantity(event) {
            if (+event > this.stock) {
                this.$fire({
                    title: 'Agotado',
                    text: `Stock agotado, solo queda ${this.stock} productos en almacén`,
                    type: 'error',
                    confirmButtonText: 'Entendido',
                    confirmButtonColor: this.btnColor,
                    cancelButtonColor: '#f44336',
                    reverseButtons: true,
                    showCancelButton: false,
                    customClass: {
                        container: this.fontFamily
                    }
                }).then(resp => {
                    if (resp.value) {
                        this.quantity = this.stock
                        this.calcTotal()
                    }
                })
            }
            this.calcTotal()
        },
        // change plus and minus
        changePlusAndMinus(type) {
            var tmpImport = 0
            switch (type) {
                case 'minus':
                    tmpImport = ((+this.price) * ((+this.quantity)-1))
                    if (tmpImport < 0) {
                        this.$notify.error('Error, el importe esperado no debe ser menor a cero, revise el campo descuento por favor.')
                        return
                    }
                    this.quantity = (+this.quantity) - 1
                    break
                case 'plus':
                    tmpImport = ((+this.price) * ((+this.quantity)+1))
                    if (tmpImport < 0) {
                        this.$notify.error('Error, el importe esperado no debe ser menor a cero, revise el campo descuento por favor.')
                        return
                    }
                    this.quantity = (+this.quantity) + 1
                    break
                default:
                    break
            }
            this.changeQuantity(this.quantity)
            this.calcTotal()
        },
        addToCart() {
            this.showAlertRequired = false
            if (this.showRequired) {
                this.showAlertRequired = true
                return
            }
            this.overlayProd = true
            const cart = {
                    prodId: this.prodId,
                    name: this.nameProd,
                    // price: this.price,
                    price: (this.quantity * this.price) + this.respMultipleVal + this.respOnlyVal,
                    quantity: this.quantity,
                    extra: this.dataExtra,
                    complements: {
                        multi: this.respMultiple,
                        only: this.respOnly
                    }
                }

            if (localStorage.getItem(this.slug)) {
                const tmpCart = JSON.parse(localStorage.getItem(this.slug))
                var size = Object.keys(tmpCart).length;
                tmpCart[size] = cart
                // tmpCart[this.prodId] = cart
                localStorage.setItem(this.slug, JSON.stringify(tmpCart))
            } else {
                let tmpCartInitial = {}
                tmpCartInitial[0] = cart
                // tmpCartInitial[this.prodId] = cart
                localStorage.setItem(this.slug, JSON.stringify(tmpCartInitial))
            }

            this.$emit('update-cart', localStorage.getItem(this.slug))

            setTimeout(() => {
                this.overlayProd = false
                this.dialogProd = false
            }, 300);
            setTimeout(() => {
                this.$confirm(
                    '',
                    'Producto agregado correctamente.',
                    'success', {
                    showCloseButton: true,
                    reverseButtons: true,
                    confirmButtonText: 'Ver carrito',
                    confirmButtonColor: this.btnColor,
                    cancelButtonText: 'Seguir comprando',
                    customClass: {
                        container: this.tmpFontFamily
                    }
                }).then(res => {
                    if (res) {
                        this.$emit('open-cart', true)
                    }
                });
            }, 500);
        },
        // calc total
        calcTotal() {
            // this.total = 0
            // this.listProdSelected.forEach(p => {
            //     this.total+=(p.price * p.quantity) - p.discount
            // });
            // this.data.payTotal = this.total.toFixed(2)
        },
        /**
         * service
         */
        sendServices() {
            if (this.$refs.refService.validate()) {
                this.$fire({
                    title: 'Realizar reserva.',
                    text: 'Recibirá un mensaje por WhatsApp para coordinar mayor datos de su reserva.',
                    type: 'info',
                    confirmButtonText: 'Continuar',
                    confirmButtonColor: this.btnColor,
                    reverseButtons: true,
                    showCancelButton: false,
                    customClass: {
                        container: this.fontFamily
                    }
                }).then(async resp => {
                    if (resp.value) {
                        this.loadingServ = true
                        const dataForm = new FormData()
                        dataForm.append('full_name', this.fullName)
                        dataForm.append('phone_number', this.phoneNumber)
                        dataForm.append('dates', this.dateReservation)
                        dataForm.append('time', this.timeReservation)
                        dataForm.append('extra', this.dataExtra)
                        dataForm.append('store', this.slug)
                        dataForm.append('prod_id', this.prodId)
                        dataForm.append('user', 'seller')

                        await axios.post('/send-service', dataForm)
                        .then((response) => {
                            // console.log(response);
                            if (response.data == 'ok') {
                                this.$fire({
                                    title: 'Reserva realizado con éxito.',
                                    text: 'Su reserva fue realizado con éxito, en un momento recibirá un mensaje de whatsapp para coordinar con mayor detalle el servicio.',
                                    type: 'success',
                                    confirmButtonText: 'Continuar',
                                    confirmButtonColor: this.btnColor,
                                    reverseButtons: true,
                                    showCancelButton: false,
                                    customClass: {
                                        container: this.fontFamily
                                    }
                                }).then(resp => {
                                    if (resp.value) {
                                        window.location.href='/'+this.slug
                                    }
                                })
                                this.full_name = ''
                                this.phone_number = ''
                                this.dates = []
                                this.time = ''
                                this.extra = ''
                                this.dialogProd = false
                                this.loadingServ = false
                            }
                        })
                        .catch((error) => {
                            // console.log(error.response);
                            if (error.response.status == 404 || error.response.status == 500) {
                                this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                            }
                            if (error.response.status == 419) {
                                this.$fire({
                                    title: 'Sesión duplicada',
                                    text: '',
                                    type: 'info',
                                    confirmButtonText: 'Entendido',
                                    confirmButtonColor: this.btnColor,
                                    reverseButtons: true,
                                    showCancelButton: false,
                                    customClass: {
                                        container: this.fontFamily
                                    }
                                }).then(resp => {
                                    if (resp.value) {
                                        window.location.href='/login'
                                    }
                                })
                            }
                            this.loadingServ = false
                        })
                    }
                })
            }
        },
        /**
         * generate
         */
        openPreviewReservation() {
            if (this.$refs.refService.validate()) {
// generate text
this.contentOrder = `SERVICIO de ${ this.nameProd } ${this.descriptionProd }

DATOS GENERALES
===============
Nombre: ${ this.fullName }
Celular: ${ this.phoneNumber }
Fecha: ${ this.dateFormatted }
Hora: ${ this.timeReservation }
Comentario extra: ${ this.dataExtra }

`
// end
                this.dialogGenerate = true
            }
        },
        // send
        async sendReservationWhatsApp() {
            this.loading = true
            const dataForm = new FormData()
            dataForm.append('full_name', this.fullName)
            dataForm.append('phone_number', this.phoneNumber)
            dataForm.append('dates', this.dateReservation)
            dataForm.append('time', this.timeReservation)
            dataForm.append('extra', this.dataExtra)
            dataForm.append('store', this.slug)
            dataForm.append('prod_id', this.prodId)
            dataForm.append('user', 'seller')

            dataForm.append('wsp_order', this.contentOrder)

            await axios.post('/generate-service', dataForm)
            .then((response) => {
                // console.log(response)
                // window.location.href = response.data
                if (response.data == 'ok') {
                    this.$fire({
                        title: 'Reserva enviada con éxito.',
                        text: '',
                        type: 'success',
                        confirmButtonText: 'Continuar',
                        confirmButtonColor: this.btnColor,
                        reverseButtons: true,
                        showCancelButton: false,
                        customClass: {
                            container: this.tmpFontFamily
                        }
                    })
                    this.dialogGenerate = false
                    this.dialogProd = false
                }
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.loading = false
            })
        }
    },
}
</script>
<style lang="scss">
.sheet-cant {
    text-align: center;
    border: 1px solid #9e9e9e !important;
    font-size: 16px;
    line-height: 25px;
    border-radius: 4px;
}
</style>
